import { Input } from 'antd';
import React, { ReactElement } from 'react';

import classes from './AccessKeys.module.css';

interface EncryptedConfig {
  accessKeyId?: string;
  secretAccessKey?: string;
}

interface AccessKeysProps {
  encryptedConfig?: EncryptedConfig;
  handleEncryptedConfig?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

function AccessKeys({ encryptedConfig, handleEncryptedConfig }: AccessKeysProps): ReactElement {
  return (
    <div className={classes.flexColumn}>
      <div className={classes.marginTop}>
        <span className={classes.boldText}>If either of these values are given, both are overwritten:</span>
      </div>
      <div className={classes.minHeight}>
        <div style={{ marginBottom: 8, fontWeight: 500 }}>Access Key Id</div>
        <Input.Password
          id="accessKeyId"
          name="accessKeyId"
          aria-describedby="access-key-id"
          onChange={handleEncryptedConfig}
          value={encryptedConfig?.accessKeyId || ''}
          autoComplete="off"
        />
      </div>
      <div className={classes.minHeight}>
        <div style={{ marginBottom: 8, fontWeight: 500 }}>Secret Access Key</div>
        <Input.Password
          id="secretAccessKey"
          name="secretAccessKey"
          aria-describedby="secret-access-key"
          onChange={handleEncryptedConfig}
          value={encryptedConfig?.secretAccessKey || ''}
          autoComplete="off"
        />
      </div>
    </div>
  );
}

export default AccessKeys;
